<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12.5001C23 18.2991 18.299 23.0001 12.5 23.0001C6.70101 23.0001 2 18.2991 2 12.5001C2 6.70113 6.70101 2.00012 12.5 2.00012C18.299 2.00012 23 6.70113 23 12.5001ZM11.086 12.5004L7.90381 9.31814L9.31802 7.90393L12.5002 11.0862L15.6821 7.90434L17.0963 9.31856L13.9145 12.5004L17.0962 15.6821L15.682 17.0963L12.5002 13.9146L9.31809 17.0967L7.90388 15.6825L11.086 12.5004Z"
      fill="#FF1E1E"
    />
  </svg>
</template>
